<!--  -->
<template>
  <div>
    <div class="content" v-loading="loading">
      <el-form label-position="left" :rules="rules" :model="queryParams" ref="ruleForm">
        <el-form-item label="规则名称：" label-width="98px" prop="rule_name">
          <el-input
            placeholder="请输入规则名称"
            maxlength="20"
            show-word-limit
            v-model="queryParams.rule_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="关键词：" label-width="98px" prop="keywords">
          <el-select
            style="width: 400px"
            v-model="queryParams.keywords"
            :multiple-limit="5"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="关键词数量最多5个，每个不可超过6个字符"
            @change="addKeyword"
          ></el-select>
        </el-form-item>
        <el-form-item
          :label="index === 0 ? '回复内容：' : ''"
          label-width="98px"
          v-for="(message, index) in messages"
          :key="index"
        >
          <Message
            :form="message"
            @change="message = $event"
            @delete="deleteMessage(index)"
          ></Message>
        </el-form-item>
        <el-form-item label-width="98px">
          <el-button @click="addMessage">添加回复内容</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="Goback">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { AddReplyRule, GetReplyRule, EditReplyRule } from '@/api/messageManagement.js';
import Message from '../components/message.vue';
import emptyMessage from '../components/message.js';
export default {
  components: { Message },
  data() {
    return {
      loading: false,
      queryParams: {
        rule_name: '',
        keywords: [],
        content: '',
      },

      rules: {
        rule_name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        keywords: [{ required: true, message: '请输入关键词', trigger: 'blur' }],
        content: [{ required: true, message: '请输入回复内容', trigger: 'blur' }],
      },
      messages: [
        {
          kind: 1, // 消息内容类型，1文字，2文章
          textContent: '', // 消息文字内容
          article: {
            art_id: '', // 文章id
            title: '', // 文章标题
            content_source_url: '', // 文章url
            cover_url: '', // 文章封面url
            digest: '', // 文章摘要
          },
        },
      ],
    };
  },
  created() {
    let title = '新建回复';
    if (this.$route.query.type === 'edit') {
      title = '编辑回复';
    }

    const breadcrumb = [
      { menu_name: '功能', menu_path: '' },
      { menu_name: '自动回复', menu_path: 'autoReply' },
      { menu_name: title },
    ];
    this.$store.commit('user/setBreadcrumb', breadcrumb);

    if (this.$route.query.type === 'edit') {
      this.loading = true;
      GetReplyRule({ rule_id: this.$route.query.rule_id }).then(({ rule }) => {
        this.queryParams.rule_name = rule.rule_name;
        this.queryParams.keywords = rule.keywords.split(',');
        // this.queryParams.content = rule.content;

        // 连调时放开
        this.messages.splice(0, this.messages.length);
        for (const item of rule.content) {
          const message = JSON.parse(JSON.stringify(emptyMessage));
          message.textContent = item;
          this.messages.push(message);
        }
        for (const item of rule.article) {
          const message = JSON.parse(JSON.stringify(emptyMessage));
          message.kind = 2;
          message.article = item;
          this.messages.push(message);
        }

        this.loading = false;
      });
    }
  },
  methods: {
    submitForm(formName) {
      // 校验是否无回复内容
      if (this.messages.length === 0) {
        this.$message.warning('至少添加一条回复内容');
        return;
      }
      // 校验是否有回复为空
      for (const message of this.messages) {
        if (message.kind === 1 && message.textContent.length === 0) {
          this.$message.warning('文字回复不可为空');
          return;
        }
        if (message.kind === 2 && message.article.art_id === '') {
          this.$message.warning('请选择文章内容');
          return;
        }
      }

      // 发送
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 拼凑回复内容
          const content = [];
          const article = [];
          for (const message of this.messages) {
            if (message.kind === 1) {
              content.push(message.textContent);
            }
            if (message.kind === 2) {
              article.push(message.article);
            }
          }
          const req = {
            app_id: this.$route.query.app_id,
            rule_name: this.queryParams.rule_name,
            keywords: this.queryParams.keywords.join(','),
            // content: this.queryParams.content,
            content,
            article,
          };
          if (this.$route.query.type === 'edit') {
            EditReplyRule({ rule: { ...req, rule_id: this.$route.query.rule_id } })
              .then(() => {
                this.$message.success('编辑成功');
                this.g_tourl(`/saas/autoReply.html?app_id=${req.app_id}`);
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          } else {
            AddReplyRule({ rule: req })
              .then(() => {
                this.$message.success('新增成功');
                this.g_tourl(`/saas/autoReply.html?app_id=${req.app_id}`);
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          }
        } else {
          return false;
        }
      });
    },
    addKeyword(val) {
      const item = val[val.length - 1];
      if (item.length > 6) {
        this.$message.warning('关键词输入不合法，每个关键词长度最大为6个字符');
        val.splice(val.length - 1, 1);
      }
    },
    Goback() {
      this.$confirm('取消将不保存当前修改，确定取消吗？', '提示')
        .then(() => {
          this.g_tourl(`/saas/autoReply.html?app_id=${this.$route.query.app_id}`);
        })
        .catch(() => {});
    },
    addMessage() {
      this.messages.push(JSON.parse(JSON.stringify(emptyMessage)));
    },
    deleteMessage(index) {
      this.messages.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  position: relative;
  height: 80px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #303133;
  border-bottom: 1px solid #edeff2;
  .details-img {
    position: absolute;
    top: 32.5px;
    left: 0;
    width: 24px;
    height: 24px;
    transform: rotateY(180deg);
  }
  .details-img:hover {
    color: rgb(47, 150, 255);
  }
  .details-return {
    position: absolute;
    top: 36px;
    width: 44px;
    height: 22px;
    left: 28px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #606266;
    letter-spacing: 0;
    cursor: pointer;
  }
  .details-return:hover {
    color: rgb(47, 150, 255);
  }
}
::v-deep.el-input {
  width: 400px;
  height: 36px;
}
.content {
  margin-top: 50px;
}
::v-deep.reply-content {
  width: 500px;
  height: 300px;
  .el-textarea__inner {
    height: 300px;
    resize: none;
  }
}
</style>
